var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.909 4.219H2.125a.322.322 0 0 1 0-.645h1.784a.322.322 0 0 1 0 .645z",
    fill: "##A6AEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.324 6.006h-5.2a.322.322 0 0 1 0-.645h5.2a.322.322 0 0 1 0 .645z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.324 7.792h-5.2a.322.322 0 0 1 0-.644h5.2a.322.322 0 0 1 0 .644z",
    fill: "##A6AEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.324 9.58h-5.2a.322.322 0 0 1 0-.645h5.2a.322.322 0 0 1 0 .644z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.67 3.574h-1.467V2.109a.322.322 0 0 0-.322-.322H8.453L6.76.094A.322.322 0 0 0 6.533 0H.338a.322.322 0 0 0-.323.322v10.782c0 .178.145.322.323.322h1.464v1.465c0 .178.145.322.323.322h1.467v1.465c0 .178.144.322.322.322h8.756a.322.322 0 0 0 .322-.322V3.896a.322.322 0 0 0-.322-.322zm-4.056-.715H6.736V.981L8.614 2.86zM.66.645H6.09V3.18c0 .178.144.323.322.323h2.359v7.277H.66V.645zm1.787 10.781h6.647a.322.322 0 0 0 .322-.322v-8.22a.322.322 0 0 0-.094-.228l-.224-.224h1.46v10.137H2.448v-1.143zm9.9 2.93h-8.11v-1.143h6.644a.322.322 0 0 0 .322-.322V4.219h1.145v10.136z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.fa2567d306a65108a40dc271bd698e65.svg";
export { ForwardRef as ReactComponent };